// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/chevron-up.svg';

export const ChevronUp = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
